import { createRouter, createWebHistory } from 'vue-router';

import lib from '@/lib';

import Layout from '@/layouts/Layout.vue';
import LayoutAdmin from '@/layouts/LayoutAdmin.vue';

import Home from '@/pages/Home.vue';

import Works from '@/pages/Works.vue';
import WorksItem from '@/pages/WorksItem.vue';

import Blog from '@/pages/Blog.vue';
import BlogItem from '@/pages/BlogItem.vue';

import Login from '@/pages/Login.vue';
import AdminMain from '@/pages/admin/Main.vue';
import AdminWorksCategories from '@/pages/admin/WorksCategories.vue';
import AdminWorksCategoriesAdd from '@/pages/admin/WorksCategoriesAdd.vue';
import AdminWorksCategoriesEdit from '@/pages/admin/WorksCategoriesEdit.vue';
import AdminWorksAdd from '@/pages/admin/WorksAdd.vue';
import AdminWorksEdit from '@/pages/admin/WorksEdit.vue';
import AdminBlogCategories from '@/pages/admin/BlogCategories.vue';
import AdminBlogCategoriesAdd from '@/pages/admin/BlogCategoriesAdd.vue';
import AdminBlogCategoriesEdit from '@/pages/admin/BlogCategoriesEdit.vue';
import AdminBlogAdd from '@/pages/admin/BlogAdd.vue';
import AdminBlogEdit from '@/pages/admin/BlogEdit.vue';

import Test1 from '@/pages/Test1.vue';
import Test2 from '@/pages/Test2.vue';

import PageNotFound from '@/pages/PageNotFound.vue';

const routes = [
	/*{
		path: '/',
		redirect: '/index',
	},*/
	{
		path: '/',
		component: Layout,
		children: [
			{
				name: 'home',
				path: '',
				component: Home,
			},
			{
				name: 'works',
				path: '/works',
				component: Works,
			},
			{
				name: 'works-item',
				path: '/works/:id',
				component: WorksItem,
			},
			{
				name: 'blog',
				path: '/blog',
				component: Blog,
			},
			{
				name: 'blog-item',
				path: '/blog/:id',
				component: BlogItem,
			},
			{
				name: 'login',
				path: '/login',
				component: Login,
				meta: {
					guest: true,
				},
			},
			
			{
				name: 'test1',
				path: '/test1',
				component: Test1,
			},
			{
				name: 'test2',
				path: '/test2',
				component: Test2,
			},
		],
	},
	{
		path: '/admin',
		component: LayoutAdmin,
		children: [
			{
				name: 'admin-main',
				path: '',
				component: AdminMain,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-works-categories',
				path: '/admin/works-categories',
				component: AdminWorksCategories,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-works-categories-add',
				path: '/admin/works-categories/add',
				component: AdminWorksCategoriesAdd,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-works-categories-edit',
				path: '/admin/works-categories/:id',
				component: AdminWorksCategoriesEdit,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-works-add',
				path: '/admin/works/add',
				component: AdminWorksAdd,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-works-edit',
				path: '/admin/works/:id',
				component: AdminWorksEdit,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-blog-categories',
				path: '/admin/blog-categories',
				component: AdminBlogCategories,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-blog-categories-add',
				path: '/admin/blog-categories/add',
				component: AdminBlogCategoriesAdd,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-blog-categories-edit',
				path: '/admin/blog-categories/:id',
				component: AdminBlogCategoriesEdit,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-blog-add',
				path: '/admin/blog/add',
				component: AdminBlogAdd,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
			{
				name: 'admin-blog-edit',
				path: '/admin/blog/:id',
				component: AdminBlogEdit,
				meta: {
					requiresAuth: true,
					is_admin: true,
				},
			},
		],
	},
	{
		name: 'logout',
		path: '/logout',
		async beforeEnter(to, from){
			await storeInstance.state.app.auth.doLogout();
			return { path: '/login' };
		},
	},
	
	{
		path: '/:pathMatch(.*)*',
		component: Layout,
		children: [
			{
				name: 'page-not-found',
				path: '',
				component: PageNotFound,
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach(async (to, from) => {
	await storeInstance.state.app.auth.doInitData();
	
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!storeInstance.state.app.auth.isAuth()) {
			return {
				//path: '/login',
				path: '/',
				params: {
					nextUrl: to.fullPath,
				},
			};
		} else {
			if (to.matched.some(record => record.meta.is_admin)) {
				if (!storeInstance.state.app.auth.isAdmin()) {
					return '/';
				}
			}
		}
	} else if(to.matched.some(record => record.meta.guest)) {
		if (storeInstance.state.app.auth.isAuth()) {
			return '/';
		}
	}
	return true;
});

export default router;
